// src/facebookPixel.js
import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false,
};

// const pixelId = 'YOUR_PIXEL_ID'; // Replace with your real Pixel ID
// 🧪 Dummy Facebook Pixel ID (random valid format, not real)
const pixelId = '123456789012345';

const initFacebookPixel = () => {
  ReactPixel.init(pixelId, null, options);
  ReactPixel.pageView(); // initial page load
};

const trackEvent = (eventName, data = {}) => {
  ReactPixel.track(eventName, data);
};

export { initFacebookPixel, trackEvent };
